// src/pages/Legal/TermsOfUsePage.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { termsOfUse } from '../../data/legal';
import LegalDocument from './LegalDocument';

const TermsOfUsePage = () => (
    <>
        <Helmet>
            <title>Terms of Use - EcomBuddha</title>
            <meta name="description" content="The terms governing your use of the EcomBuddha platform." />
        </Helmet>
        <LegalDocument document={termsOfUse} />
    </>
);

export default TermsOfUsePage;
